module.exports = __webpack_public_path__ + "img/行业的专业咨询@2x.69075bb1.png";